/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesGet } from "../funcs/killswitchesGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchDetail } from "../models/components/killswitchdetail.js";
import {
  KillswitchesGetRequest,
  KillswitchesGetSecurity,
} from "../models/operations/killswitchesget.js";
import { unwrapAsync } from "../types/fp.js";
export type KillswitchQueryData = KillswitchDetail;

export function prefetchKillswitch(
  queryClient: QueryClient,
  client$: GramCore,
  security: KillswitchesGetSecurity,
  request: KillswitchesGetRequest,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildKillswitchQuery(
      client$,
      security,
      request,
      options,
    ),
  });
}

export function buildKillswitchQuery(
  client$: GramCore,
  security: KillswitchesGetSecurity,
  request: KillswitchesGetRequest,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<KillswitchQueryData>;
} {
  return {
    queryKey: queryKeyKillswitch({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function killswitchQueryFn(
      ctx,
    ): Promise<KillswitchQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(killswitchesGet(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyKillswitch(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "killswitches", "get", parameters];
}
